module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAAAXNSR0IArs4c6QAAAI1JREFUKFONkbsNAjEQRN/0RXIZGUhcQDeUQEATSMTERFcIGV0MWmTD2joJW3Lw7Pl4Zdm+AFdJC0DPcVaXbG+AGzCHoedGXNKGDKrOkYaveKShESfDHdhLepTG4N2a+AxsY0t62v5xnjZdTJJePecBa8KqMEI/4n+J+VNOwBGoiQ33P3gAlnhjaWk4i98rO3ZmRkWSNQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/case-more.png
// module id = 7SPh
// module chunks = 0